var rtl_rtlignore_default = {
  "rtl": "_5DwiC",
  "ltr": "E-qnb"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
